import { Box, ModalBody } from "@twilio-paste/core";
import { RefObject } from "react";
import { ActionName } from "../../types";
import ConvoModal from "./ConvoModal";
import ModalInputField from "./ModalInputField";
import AddParticipantFooter from "./addParticipantFooter";

interface AddSMSParticipantModalProps {
  name: string;
  isModalOpen: boolean;
  title: string;
  proxyName: string;
  setName: (name: string) => void;
  setProxyName: (name: string) => void;
  error: string;
  errorProxy: string;
  nameInputRef: RefObject<HTMLInputElement>;
  handleClose: () => void;
  onBack: () => void;
  action: () => void;
}

const AddSMSParticipantModal: React.FC<AddSMSParticipantModalProps> = (
  props: AddSMSParticipantModalProps
) => {
  return (
    <>
      <ConvoModal
        handleClose={() => props.handleClose()}
        isModalOpen={props.isModalOpen}
        title={props.title}
        modalBody={
          <ModalBody>
            <h3>Adicionar participante SMS</h3>
            <Box as="form">
              <ModalInputField
                isFocused={true}
                label="Celular"
                input={props.name}
                placeholder="123456789012"
                onChange={props.setName}
                error={props.error}
                help_text="O número de celular do participante."
                prefixType="SMS"
              />
              <ModalInputField
                label="Proxy Twilio"
                input={props.proxyName}
                placeholder="123456789012"
                onChange={props.setProxyName}
                error={props.errorProxy}
                // error_text="Enter a valid Twilio phone number."
                help_text="O número de telefone Twilio usado pelo participante em Conversas."
                prefixType="SMS"
              />
            </Box>
          </ModalBody>
        }
        modalFooter={
          <AddParticipantFooter
            isSaveDisabled={!props.name || !props.proxyName || !!props.error}
            actionName={ActionName.Save}
            onBack={() => {
              props.onBack();
            }}
            action={props.action}
          />
        }
      />
    </>
  );
};

export default AddSMSParticipantModal;
